import React, { useState } from "react";
import { useTaskShareContext } from "store/contexts/taskShareContext";
import Loader from "components/Loader";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";

export default ({ total, allList }) => {
  const { ShareTodoListItem, isloading } = useTaskShareContext();
  const [selectedListId, setListId] = useState();
  const [showSelector, setSelector] = useState(false);

  function checkAccronym(name) {
    var str = name;
    var matches = str.split(" ");

    var result = matches.map((string) => string.charAt(0));

    if (result.length > 2) {
      result.splice(2, result.length - 2);
    }

    return result.join("");
  }

  const handleShareList = async (list, shareComment) => {
    try {
      setListId(list.id);
      await ShareTodoListItem(list, shareComment);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSelector = (id) => {
    if (showSelector) {
      setSelector(null);
      return;
    }
    setSelector(id);
  };

  return (
    <div>
      {total !== 0 &&
        allList.map((list) => (
          <ul
            className={classNames({
              "todo-list-ul": true,
              disabled: isloading ? true : false,
            })}
            key={list?.id}
            onClick={() => handleSelector(list?.id)}
          >
            <li style={{ marginBottom: "10px" }}>
              <div className="todo-list-data">
                <div className="list-data">
                  <span className="todoListAvatar">
                    <span>{checkAccronym(list?.name)}</span>
                  </span>
                  <span className="todo-list-name">{list.name}</span>
                </div>
                {isloading && selectedListId === list?.id && (
                  <Loader width={30} height={30} />
                )}
              </div>
              <CSSTransition
                in={showSelector === list?.id ? true : false}
                timeout={300}
                unmountOnExit
                classNames="dropdown-element"
              >
                <div className="todoCommentMessage">
                  <span>Do you also want to share task engagements?</span>
                  <span className="actionButtons">
                    <span onClick={() => handleShareList(list, true)}>Yes</span>
                    <span onClick={() => handleShareList(list, false)}>No</span>
                  </span>
                </div>
              </CSSTransition>
            </li>
          </ul>
        ))}
      {total === 0 && <div>No List</div>}
    </div>
  );
};
